module.exports = "/images/Blue_Pill.png?1bc6d9b6da879684ecd07a56c33f6d64";